import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Input, FormFeedback } from 'reactstrap';


class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.imputaciones.titulosSeparaciones.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Parámetro"}
                buttonIcon={"fa fa-search fa-lg"}
                buttonTitle={"Ver parámetro"}
                className={"ui-modal-dialog"}
                closeButton={true}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Datos del parámetro</h5>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Nombre</label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/TitulosSeparaciones/Detail.js